module.exports = __webpack_public_path__ + "static/media/wechatpay.f2880030.png";